var map = {
	"./arrow-circle.svg": "2a50",
	"./arrow-left.svg": "f6db",
	"./arrow.svg": "d4d9",
	"./close.svg": "bb7c",
	"./cogwheels.svg": "6403",
	"./download.svg": "8215",
	"./download1.svg": "ecdf",
	"./email.svg": "da8d",
	"./history.svg": "69ff",
	"./location.svg": "4093",
	"./menu-side.svg": "bb85",
	"./philosophy.svg": "c13d",
	"./phone.svg": "1f9a",
	"./placeholder.svg": "1311",
	"./play.svg": "af53",
	"./plus.svg": "4eb1",
	"./search.svg": "0a17",
	"./send.svg": "f95f",
	"./strategy.svg": "279f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";